export const colors = {
    main: "#00b0bb",
    bg: "#f8f9fb",
    darkBg: "#f0f0f0",
    text: "#04222b",
    lightBlue: "#e2eeff",
    darkGreen: "#042b20",
    pink: "#8b5cf6",
    neonPink: "#FF10F0",
    neonPinkBg: "#F8E4FF"
};
